import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Deploy history

const DeployHistory = () => import('@/views/deploy/History')

// Views - Banners
const ManageBanners = () => import('@/views/banners/ManageBanners')
const CreateBanner = () => import('@/views/banners/CreateBanner')
const CreateSimilarBanner = () => import('@/views/banners/CreateSimilarBanner')
const EditBanner = () => import('@/views/banners/EditBanner')
const ReplaceBannerContent = () => import('@/views/banners/ReplaceBannerContent')

// Matches
const ManageMatches = () => import('@/views/matches/ManageMatches')
const CreateMatch = () => import('@/views/matches/CreateMatch')
const EditMatch = () => import('@/views/matches/EditMatch')

// Views template
const Template = () => import('@/views/templates/Template')

// Views bookmakers
const Bookmakers = () => import('@/views/bookmakers/bookmakers')

// Views Affiliate
const Affiliate = () => import('@/views/affiliates/Affiliate')

// Views Campaigns
const Campaigns = () => import('@/views/campaigns/Campaigns')

// Views Statistics
const Statistics = () => import('@/views/statistics/Statistics')

// Views Referrers
const Referrers = () => import('@/views/referrers/Referrers')

// Views Slugs
const Slugs = () => import('@/views/slugs/Slugs')

// Views CSS
const CSS = () => import('@/views/css/Manage')
const CSSUpload = () => import('@/views/css/Upload')
const CSSCreate = () => import('@/views/css/Create')
const CSSUpdate = () => import('@/views/css/Update')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')

// Views - Auth
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const Logout = () => import('@/views/pages/Logout')

const Users = () => import('@/views/users/Users')
// const User = () => import('@/views/users/User')

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    const proceed = () => {
      if (to.meta.permission) {
        switch (to.meta.permission) {
          case 'user':
            if (store.getters.permission >= 1) {
              next()
            } else {
              next('/pages/500')
            }
            break
            /*
          If the route that requires authentication is an owner and the permission
          the user has is greater than or equal to 1 (an owner or higher), we allow
          access. Otherwise we redirect back to the cafes.
        */
          case 'editor':
            if (store.getters.permission >= 2) {
              next()
            } else {
              next('/banners/manage')
            }
            break
            /*
          If the route that requires authentication is an admin and the permission
          the user has is greater than or equal to 2 (an owner or higher), we allow
          access. Otherwise we redirect back to the cafes.
        */
          case 'admin':
            if (store.getters.permission >= 3) {
              next()
            } else {
              next('/pages/404')
            }
            break
        /*
          If the route that requires authentication is a super admin and the permission
          the user has is equal to 3 (a super admin), we allow
          access. Otherwise we redirect back to the cafes.
        */
        }
      } else {
        next()
      }
    }
    return proceed()
  }
  next('/auth/login')
}

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'editor'
          }
        },
        {
          path: 'deploy/history',
          name: 'history',
          component: DeployHistory,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'editor'
          }
        },
        {
          path: 'users',
          name: 'Users',
          component: Users,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'admin'
          }
        },
        {
          path: 'banners',
          name: 'Banners',
          redirect: '/banners/manage',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: 'Manage Banners',
              component: ManageBanners,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'user'
              }
            },
            {
              path: 'create',
              name: 'Create Banner',
              component: CreateBanner,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            },
            {
              path: 'edit/:id',
              name: 'banner.edit',
              component: EditBanner,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            },
            {
              path: 'replace',
              name: 'banner.replace',
              component: ReplaceBannerContent,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'admin'
              }
            },
            {
              path: 'create/similar/:id',
              name: 'Create Similar Banner',
              component: CreateSimilarBanner,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            }
          ]
        },
        {
          path: 'css',
          name: 'CSS',
          redirect: '/css/manage',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: 'Manage',
              component: CSS,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            },
            {
              path: 'upload',
              name: 'Upload',
              component: CSSUpload,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            },
            {
              path: 'create',
              name: 'Create',
              component: CSSCreate,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            },
            {
              path: 'update/:filename',
              name: 'Update',
              component: CSSUpdate,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            }
          ]
        },
        {
          path: 'matches',
          name: 'Matches',
          redirect: '/matches/manage',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: 'Manage Matches',
              component: ManageMatches,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'user'
              }
            },
            {
              path: 'create',
              name: 'Create Match',
              component: CreateMatch,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            },
            {
              path: 'edit/:id',
              name: 'match.edit',
              component: EditMatch,
              beforeEnter: ifAuthenticated,
              meta: {
                permission: 'editor'
              }
            }
          ]
        },
        {
          path: 'bookmakers',
          name: 'Bookmakers',
          component: Bookmakers,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'editor'
          }
        },
        {
          path: 'templates',
          name: 'Templates',
          component: Template,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'editor'
          }
        },
        {
          path: 'affiliates',
          name: 'Affiliates',
          component: Affiliate,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'editor'
          }
        },
        {
          path: 'campaigns',
          name: 'Campaigns',
          component: Campaigns,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'editor'
          }
        },
        {
          path: 'affcodes',
          name: 'Affiliate Codes',
          component: Statistics,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'admin'
          }
        },
        {
          path: 'referrers',
          name: 'Referrers',
          component: Referrers,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'admin'
          }
        },
        {
          path: 'slugs',
          name: 'Slugs',
          component: Slugs,
          beforeEnter: ifAuthenticated,
          meta: {
            permission: 'editor'
          }
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      beforeEnter: ifAuthenticated,
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }, {
          path: 'logout',
          name: 'logout',
          component: Logout
        }
      ]
    }
  ]
}

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})
